import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { ProfilComponent } from './components/profil/profil.component';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { UserInfoService } from '../../services/security/user-info.service';
import { MatDialogModule } from '@angular/material/dialog';
import { BreadcrumbComponent } from '../../commun/breadcrumb/breadcrumb.component';
import { MatListModule } from '@angular/material/list';
import { FinancialService } from '../../budget/service/financial.service';

@NgModule({
    imports: [
    CommonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    RouterModule,
    ReactiveFormsModule,
    MatDividerModule,
    FormsModule,
    MatAutocompleteModule,
    MatMenuModule,
    NgOptimizedImage,
    MatTooltipModule,
    MatSelectModule,
    MatDialogModule,
    MatListModule,
    MainLayoutComponent, ProfilComponent, BreadcrumbComponent
],
    providers: [UserInfoService, FinancialService, CurrencyPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [MainLayoutComponent]
})
export class MaterialLayoutModule {}
